/* Bloque 155: validación en el navegador de los formularios de contacto/solicitud.
   Única fuente de las reglas de correo y teléfono. Cada formulario llama a ZTKForm.init(form).
   - Sin JavaScript siguen valiendo required / type="email" / type="tel" nativos.
   - Con JavaScript se desactiva la burbuja nativa (noValidate) y se muestran los mensajes junto al campo
     (role="alert", aria-invalid, aria-describedby). Si algo falla NO se envía: se corta el evento 'submit'
     antes de que lo vean los manejadores propios de cada formulario. */
(function () {
  if (window.ZTKForm) return;

  var MSG_REQUIRED = 'Este campo es obligatorio.';
  var MSG_EMAIL = 'Introduce un correo electrónico válido.';
  var MSG_PHONE = 'Introduce un teléfono de contacto (mínimo 9 dígitos).';

  function isEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
  }

  // Permisivo: prefijo internacional (+34, 0034), espacios, guiones, puntos y paréntesis; mínimo 9 dígitos.
  function isPhone(v) {
    if (!/^[\d\s+().\-]+$/.test(v)) return false;
    return v.replace(/\D/g, '').length >= 9;
  }

  function messageFor(input) {
    var v = (input.value || '').trim();
    if (!v) {
      if (input.type === 'email') return MSG_EMAIL;
      if (input.type === 'tel') return MSG_PHONE;
      return MSG_REQUIRED;
    }
    if (input.type === 'email' && !isEmail(v)) return MSG_EMAIL;
    if (input.type === 'tel' && !isPhone(v)) return MSG_PHONE;
    return '';
  }

  function errorEl(input) {
    var id = (input.id || input.name) + '-error';
    var el = document.getElementById(id);
    if (!el) {
      el = document.createElement('p');
      el.id = id;
      el.className = 'ztk-field-error';
      el.setAttribute('role', 'alert');
      el.hidden = true;
      input.insertAdjacentElement('afterend', el);
    }
    return el;
  }

  function setState(input, message) {
    var el = errorEl(input);
    var describedBy = (input.getAttribute('aria-describedby') || '').split(' ').filter(function (x) { return x && x !== el.id; });
    if (message) {
      el.textContent = message;
      el.hidden = false;
      input.setAttribute('aria-invalid', 'true');
      input.classList.add('ztk-field-invalid');
      describedBy.push(el.id);
    } else {
      el.textContent = '';
      el.hidden = true;
      input.removeAttribute('aria-invalid');
      input.classList.remove('ztk-field-invalid');
    }
    if (describedBy.length) input.setAttribute('aria-describedby', describedBy.join(' '));
    else input.removeAttribute('aria-describedby');
  }

  function requiredFields(form) {
    return Array.prototype.slice.call(form.querySelectorAll('input[required], textarea[required], select[required]'))
      .filter(function (el) { return !el.disabled && el.type !== 'hidden' && !el.hidden; });
  }

  function validate(form) {
    var first = null;
    requiredFields(form).forEach(function (input) {
      var message = messageFor(input);
      setState(input, message);
      if (message && !first) first = input;
    });
    if (first) first.focus();
    return !first;
  }

  function clear(form) {
    requiredFields(form).forEach(function (input) { setState(input, ''); });
  }

  function init(form) {
    if (!form || form.dataset.ztkValidation) return;
    form.dataset.ztkValidation = '1';
    form.noValidate = true;

    // Fase de captura: se ejecuta antes que los listeners propios del formulario.
    form.addEventListener('submit', function (event) {
      if (!validate(form)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);

    // Al corregir un campo marcado como inválido se revalida en directo.
    form.addEventListener('input', function (event) {
      var input = event.target;
      if (input && input.getAttribute && input.getAttribute('aria-invalid') === 'true') {
        setState(input, messageFor(input));
      }
    });
  }

  window.ZTKForm = { init: init, validate: validate, clear: clear, isEmail: isEmail, isPhone: isPhone };
})();
